import React from "react"
import PropTypes from "prop-types"

const Search = ({ fillColor }) => (
  <svg
    width="19"
    height="15"
    viewBox="0 0 19 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      r="6.15261"
      transform="matrix(-1 0 0 1 7.15257 7.15261)"
      stroke={fillColor}
      strokeWidth="2"
    />
    <line
      x1="1"
      y1="-1"
      x2="5.74354"
      y2="-1"
      transform="matrix(0.816321 0.577598 0.577598 -0.816321 12.7776 9.7486)"
      stroke={fillColor}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

Search.propsTypes = {
  fillColor: PropTypes.string,
}

Search.defaultProps = {
  fillColor: "#082551",
}

export { Search }
